import { Scene, ArcRotateCamera, SceneLoader, HavokPlugin, Vector3, Database } from '@babylonjs/core';
import HavokPhysics from '@babylonjs/havok'
import "@babylonjs/core/Debug/debugLayer";
import { Inspector } from '@babylonjs/inspector';
import { World } from "./World";
import { Skybox } from "./Skybox";
import { GLTFFileLoader } from '@babylonjs/loaders'
import { StageManager } from '../stages/StageManager';
import { GlobalObject } from './../utils/GlobalObject';
import { Player } from '../displayObject/player/Player';

export class Engine {
  private _world?: World;
  private scene?: Scene;
  private camera?: ArcRotateCamera;
  private canvas?: HTMLCanvasElement;
  public loopFuncMap?: any;
  private main: any = {};
  private skybox?: Skybox;
  public playerObj?: Player;

  private stageManager?: StageManager;


  constructor(canvasElement: HTMLCanvasElement) {
    // @ts-ignore
    //window.engine = this;
    this.main = GlobalObject.getInstance().main;
    this.initStage(canvasElement);
  }
  public async initStage(canvasElement: HTMLCanvasElement) {
    this.canvas = canvasElement as HTMLCanvasElement;
    this._world = new World(this.canvas);
    await this._world.init();
    this.camera = this._world.camera;
    this.scene = this._world.scene;
    GlobalObject.getInstance().setScene(this.scene);
    GlobalObject.getInstance().setCamera(this.camera);
    GlobalObject.getInstance().setLoopFunc(this._world.loopFuncMap);

    //Database.IDBStorageEnabled = true;

    this.scene.shadowsEnabled = true;
    //this.showDebugLayer();

    (window as any).Vector3 = Vector3;

    // 准备gltfloader plugin
    SceneLoader.RegisterPlugin(new GLTFFileLoader());
    GLTFFileLoader.IncrementalLoading = false;

    const response = await fetch('resources/source.json');
    const source = await response.json();
    GlobalObject.getInstance().setSource(source.data);

    // 天空盒和环境贴图
    this.skybox = new Skybox(this.scene);

    // 显示场景
    this.stageManager = new StageManager(this.scene);
    //this.main.stageManager = this.stageManager;

    this.addPlayer();

    // const postProcess = new FxaaPostProcess("fxaa", 1.0, this.camera);
  }
  private addPlayer() {
    if (!this.playerObj) {
      this.playerObj = new Player(this.scene as Scene, this.camera as ArcRotateCamera);
      GlobalObject.getInstance().setPlayer(this.playerObj);
    }
  }
  public showDebugLayer() {
    if (this.scene) {
      //不带ES 模块的方法
      //this.scene.debugLayer.show({embedMode: true});
      // 使用使用 ES 模块 import { Inspector } from '@babylonjs/inspector';
      Inspector.Show(this.scene, { embedMode: true });  //embedMode true->Scene Explorer / Inspector 在同一边
    }
  }
  private testHqlFancility() {
    let reqObj = { macno: '018_010', sid: '12' };
    let qqq2 = this.getSoapData(reqObj);
    console.log(qqq2);
    /*
    const res = await fetch("/api/htcmdmapp/services/htc?wsdl", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(),
    })
    console.log(res);
    */
  }
  // 请求通用函数
  private async getSoapData(params: any) {
    const xml = this.requestXml('getBillboardData', params);
    const url = '/api/htcmdmapp/services/htc'
    const res = await this.soap('/api/test', xml);
    const pice = 'ns1:out'
    let response: any = res.split(pice)[1];
    console.log(response);
    response = response.slice(1, -2);
    response = JSON.parse(response);
    return response.data;
  }


  // 拼凑请求片段
  private requestXml(method: any, params: any) {
    const soapRequest = `
    <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
            <${method} xmlns="http://www.htc.cn/ws/htc">
               <in0>${JSON.stringify(params)}</in0>
            </${method}>
        </soap:Body>
    </soap:Envelope>`;
    return soapRequest;
  }
  private async soap(url: string, data: string) {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data
    });
    console.log(res);
    const text = await res.text();
    return text;
  }
}
